import { useTranslation } from 'react-i18next';

import { FieldComponent } from 'libs/form';
import { ZoneInputBox } from '../styled';
import { Input, Inputs, Interface, Wrapper, Block, ZoneLabel } from './daily-tariffication.styled';

export const DailyTariffication = (props) => {
  const { color, display, disabled } = props;

  const { t } = useTranslation();

  return (
    <Interface color={color} display={display ? 'block' : 'none'}>
      <Wrapper>
        <Block>
          <Inputs>
            <Input>
              <ZoneLabel>{t('form.Стоимость суток')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="day_cost" title={t('form.Стоимость суток')} type="text" naturalNumber withZero maxValueLength={8} mask={{ suffix: t('form. руб') }} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Начало суток')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="day_start" title={t('form.Начало суток')} type="time" maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Бесплатное время')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent type="text" name="free_interval" title={t('form.Бесплатное время')} naturalNumber withZero maxValueLength={5} disabled={disabled} mask={{ suffix: t('form. мин') }} />
              </ZoneInputBox>
            </Input>
          </Inputs>
        </Block>
      </Wrapper>
    </Interface>
  );
};
